export default __webpack_public_path__ + "static/media/mannaev_banner.378080e6.png";